<template>
  <div class="header">
    <ul class="headerlog">
      <li>
        <img src="/Images/logo.png" />
      </li>
      <li>
        <span> {{ $t('header.siteName') }}</span>
      </li>
    </ul>
    <nav>
      <input type="checkbox" id="togglebox" />
      <!-- //使用label元素并指定for属性与input元素绑定 -->
      <label class="burgerMenu" for="togglebox">
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
      </label>
      <ul class="headerNavMenu">
        <li
          class="menu"
          v-if="isMerchant"
          :class="notification"
          @click="select('0')"
        >
          {{ $t('header.notificaton') }}
        </li>
        <li class="menu" :class="shop" @click="select('6')">
          {{ $t('header.shop') }}
        </li>
        <li class="menu" :class="evoucher" @click="select('1')">
          {{ $t('header.eVoucher') }}
        </li>
        <li class="menu" :class="qrcode" @click="select('2')">
          {{ $t('header.qrCode') }}
        </li>
        <li class="menu" :class="invite" @click="select('3')">
          {{ $t('header.invitation') }}
        </li>
        <li class="menu langMenuli" @click="localize()">
          <img :src="language" />
        </li>
        <li class="settingMenuli">
          <div @click="showEditUser">
            <ul class="userNameMenuUl">
              <li>{{ userName }}</li>
              <li>
                {{ $t('settingMenu.setting') }}
              </li>
            </ul>
            <ul class="headPicMenuUl">
              <li>
                <img :src="pictureBase64" />
              </li>
            </ul>
            <ul class="editUser" :style="{ display: isShowEditUser }">
              <li @click="select('4')">{{ $t('settingMenu.profile') }}</li>
              <li @click="select('5')">{{ $t('settingMenu.password') }}</li>
              <li @click="logout()">{{ $t('settingMenu.logout') }}</li>
            </ul>
          </div>
        </li>
      </ul>
    </nav>
  </div>
</template>
<script>
import msalInstance from './../../msal';

export default {
  name: 'Header',
  data() {
    return {
      notification: '',
      shop: '',
      evoucher: 'menuSelected',
      qrcode: '',
      invite: '',
      isShowEditUser: 'none',
      language: '',
      userName: '',
      //pictureBase64:''
      isMerchant: ''
    };
  },
  mounted: function () {
    if (this.$i18n.locale == 'ch-TC') {
      this.language = '/Images/lan_CH.png';
    } else {
      this.language = '/Images/lan_EN.png';
    }
    let user = this.$store.getters.get_user_Info_cache;
    if (user) {
      this.userName = user.firstName;
      if (user.isMerchant) this.isMerchant = false;
      else this.isMerchant = true;
    }
  },
  methods: {
    showEditUser() {
      if (this.isShowEditUser == 'none') {
        this.isShowEditUser = 'block';
      } else {
        this.isShowEditUser = 'none';
      }
    },
    checkToggleBox() {
      var checkbox = document.getElementById('togglebox');
      if (checkbox && checkbox.checked) {
        checkbox.checked = false;
      }
    },
    select(p) {
      this.notification = '';
      this.shop = '';
      this.evoucher = '';
      this.qrcode = '';
      this.invite = '';

      switch (p) {
        case '0':
          this.notification = 'menuSelected';
          this.checkToggleBox();
          this.$router.push('/notification');
          break;
        case '1':
          this.evoucher = 'menuSelected';
          this.checkToggleBox();
          this.$router.push('/transactions');
          break;
        case '2':
          this.qrcode = 'menuSelected';
          this.checkToggleBox();
          this.$router.push('/qrcode');
          break;
        case '3':
          this.invite = 'menuSelected';
          this.checkToggleBox();
          if (this.$route.path != '/invite') {
            this.$router.push('/invite');
          }
          break;
        case '4':
          {
            this.getUserInfo();
          }
          break;
        case '5':
          window.location.href = process.env.VUE_APP_AAD_B2C_CHANGE_PWD;
          break;
        case '6':
          this.shop = 'menuSelected';
          this.checkToggleBox();
          this.$router.push({ path: '/shop' });
          break;
      }
    },
    localize() {
      this.checkToggleBox();
      if (this.$i18n.locale == 'ch-TC') {
        this.language = '/Images/lan_EN.png';
        this.$i18n.locale = 'en-US';
      } else {
        this.language = '/Images/lan_CH.png';
        this.$i18n.locale = 'ch-TC';
      }
      this.$store.dispatch('setLocaleSetting', this.$i18n.locale);
      this.getshopcollection(true);
    },
    logout() {
      this.$store.dispatch('setSignininfo', '');
      msalInstance.logoutRedirect();
    },
    getUserInfo: function () {
      console.log('getUserInfo');
      this.checkToggleBox();
      let self = this;
      self.$axios
        .get('/User')
        .then(function (res) {
          let user = res;
          if (user) {
            self.$store.dispatch(
              'setServerpictureBase64',
              decodeURIComponent(user.pictureBase64)
            );
            user.pictureBase64 = '';
            self.$store.dispatch('setuserInfocache', user);
            if (!user.isVerifying) {
              self.$router.push('/UserInfo/EditUser');
            } else {
              self.$router.push('/UserInfo/EditingUser');
            }
          } else {
            self.$router.push('/401');
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getshopcollection(needReload) {
      if (!this.$store.getters.get_Signin_info) {
        return;
      }
      //获取新的shopcollection
      let user = this.$store.getters.get_user_Info_cache;
      if (user) {
        if (user.isMerchant)
          this.$utility.getShopsbyMerchant(user.merchantId, false, needReload);
        else this.$utility.getShopsbyShop(user.shopid, false, needReload);
      }
    },
    initMenu(path) {
      this.notification = '';
      this.shop = '';
      this.evoucher = '';
      this.qrcode = '';
      this.invite = '';
      let $path = path ? path : this.$route.path;
      switch ($path) {
        case '/transactions':
          this.evoucher = 'menuSelected';
          break;
        case '/':
        case '/notification':
          this.notification = 'menuSelected';
          break;
        case '/shop':
          this.shop = 'menuSelected';
          break;
        case '/qrcode':
          this.qrcode = 'menuSelected';
          break;
        case '/invite':
          this.invite = 'menuSelected';
          break;
        default:
          break;
      }
    }
  },
  created() {
    this.initMenu();
    this.getshopcollection();
  },
  computed: {
    pictureBase64: function () {
      return this.$store.state.picture_Base64;
    }
  },
  watch: {
    $route(to) {
      this.initMenu(to.path);
    }
  }
};
</script>
<style scoped>
.header {
  width: 100%;
  height: 70px;
  border-bottom: 2px solid #f1f3f4;
  display: flex;
  background: #f3f3f3;
  margin-top: 3px;
}
.header > ul {
  display: flex;
}
.menu {
  font-size: 15px;
  font-weight: 500;
  color: #11254a;
  cursor: pointer;
  height: 70px;
  width: 100px;
  text-align: center;
  line-height: 70px;
}
.menuSelected {
  background: white;
}
.editUser {
  position: absolute;
  display: flex;
  flex-flow: column;
  top: 70px;
  left: 0px;
  background: #c6cbd1;
  width: 140px;
  height: 150px;
  display: none;
  z-index: 999;
}
.editUser li {
  margin-top: 20px;
  text-align: center;
  color: #172a4d;
}

.headerlog {
  width: 50%;
}
.headerlog > li:last-child span {
  vertical-align: middle;
  display: table-cell;
  height: 70px;
}

.headerlog > li:first-child img {
  margin-top: 15px;
  margin-left: 60px;
  height: 40px;
}
.headerlog > li:last-child {
  font-size: 200%;
  font-weight: 500;
  margin-left: 30px;
  color: #11254a;
}

/* 原代码提取的样式 */
.headerNavMenu {
  display: flex;
  justify-content: flex-end;
}
.langMenuli {
  background: #dddee2;
  width: 70px;
}
.langMenuli > img {
  height: 30px;
  width: 30px;
}

.settingMenuli {
  font-size: 14px;
  font-weight: 500;
  background: #c6cbd1;
  width: 140px;
  height: 70px;
}
.settingMenuli > div {
  display: flex;
  padding: 14px 14px 14px 4px;
  position: relative;
  cursor: pointer;
}
.userNameMenuUl {
  flex-flow: column;
  flex: 1 1 60%;
}
.userNameMenuUl > li:first-child {
  text-align: right;
  width: 75px;
}
.userNameMenuUl > li:last-child {
  color: #172a4d;
  text-align: right;
  padding-right: 5px;
}
.headPicMenuUl {
  flex-flow: column;
  flex: 1 1 60%;
}

.headPicMenuUl > li > img {
  margin-left: 5px;
  width: 42px;
  height: 42px;
  object-fit: cover;
}

/* 新增样式 */
nav {
  width: 50%;
  margin: 0;
  padding: 0;
}

nav input[type='checkbox'],
.burgerMenu {
  position: absolute;
  right: 4%;
  top: 10px;
  display: none;
}

/*--使用媒体查咨询--*/
@media (max-width: 862px) {
  .headerlog > li:last-child span {
    display: none;
  }
}
@media (max-width: 1240px) {
  nav {
    flex: 1 1 0%;
    justify-content: flex-end;
    margin: 0;
    padding: 0;
    width: 20%;
    z-index: 888;
  }
  /*显示菜单图标，并指定光标样式*/
  .burgerMenu {
    display: block;
    cursor: pointer;
    margin-top: 10px;
  }
  .icon-bar {
    background-color: #000;
    display: block;
    width: 22px;
    height: 2px;
    border-radius: 1px;
    margin-top: 5px;
  }
  /* //隐藏菜单列表 */
  .headerNavMenu {
    display: none;
  }

  /* //设置checkbox被选中时显示菜单 */
  nav input[type='checkbox']:checked ~ ul {
    display: block;
    background-color: #f3f3f3;
  }

  /* 设置列表项样式 */
  .menu {
    font-size: 12px;
    font-weight: 500;
    color: #11254a;
    cursor: pointer;
    text-align: center;
    line-height: 70px;
    width: auto;
  }

  .settingMenuli {
    font-size: 14px;
    font-weight: 500;
    background: #c6cbd1;
    width: auto;
    height: 70px;
  }

  .userNameMenuUl > li:first-child {
    text-align: right;
    width: auto;
  }
  .editUser {
    position: absolute;
    display: flex;
    flex-flow: column;
    top: 70px;
    left: 0px;
    background: #c6cbd1;
    width: 100%;
    height: 150px;
    display: none;
    z-index: 999;
  }
}

@media (max-width: 420px) {
  .settingMenuli > div {
    padding-top: 4px;
  }
}
</style>
